import commonApi from './CommonApi.js';

var qs = require('querystring');

export default {
	getAll: async (parameter) => {
		return await commonApi().get('/v1/azureSearch/getAll',
				{
					params: parameter,
					paramsSerializer: (params) => {
						return qs.stringify(params);
					}
				})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getAiSearchResults: async (parameter) => {
		return await commonApi().get('/v1/azureSearch/getAiSearchResults',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	checkTotalCount: async (parameter) => {
		return await commonApi().get('/v1/azureSearch/checkTotalCount',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	exportToExcel: async (parameters) => {
		return await commonApi().get('/v1/azureSearch/exportToExcel',
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				let fileName = 'Notifications.xlsx';
				let fileURL = window.URL.createObjectURL(new Blob([response.data]));
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
				return { success: true };
			})
			.catch((error) => {
				console.log(error.response);
				return { success: false };
			});
		},
	allInformationExportToExcel: async (parameters) => {
		return await commonApi().get('/v1/azureSearch/allInformationExportToExcel',
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				let fileName = 'NotificationsAndTradeConcerns.xlsx';
				let fileURL = window.URL.createObjectURL(new Blob([response.data]));
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
				return { success: true };
			})
			.catch((error) => {
				console.log(error.response);
				return { success: false };
			});
		},
	exportFullDataToExcel: async (parameters) => {
		return await commonApi().get('/v1/azureSearch/exportFullDataToExcel',
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				let fileName = 'Notifications.xlsx';
				let fileURL = window.URL.createObjectURL(new Blob([response.data]));
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
				return { success: true };
			})
			.catch((error) => {
				console.log(error.response);
				return { success: false };
			});
	},
	getDolLink: async (parameter) => {
		return await commonApi().get('/v1/azureSearch/getDolLink',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
	getDownloadLinks: async (parameter) => {
		return await commonApi().get('/v1/azureSearch/getDownloadLinks',
			{
				params: parameter,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				}
			})
			.then((response) => {
				if (response.status == 200) {
					return response.data;
				} else {
					console.log(response);
					return {};
				}
			})
			.catch((error) => {
				console.log(error);
				return {};
			});
	},
}